export const ApiError = {
  NOT_LOGGED_IN: 'NOT_LOG_IN',
  REQUEST_RATE_EXCEEDED: 'CMN-301', // Detected by HTTP status code 429 (Too Many Requests)
  SESSIONS_NUMBER_EXCEEDED: 'OAU-213',
  ACCESS_TOKEN_CORRUPTED: 'OAU-129',
};
